export { default } from './GenerateAI';
